import { Input, InputProps } from '@mui/joy';
import classNames from 'classnames';
import { ChangeEvent, ReactElement, RefObject } from 'react';

interface S_TextInputProps extends Omit<InputProps, 'onChange' | 'onBlur'> {
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  maxLength?: number;
  min?: number;
  max?: number;
  step?: number;
  innerRef?: RefObject<HTMLInputElement | null>;
}

export const S_TextInput = ({ onBlur, onChange, className, maxLength, min, max, step, innerRef, tabIndex, ...rest }: S_TextInputProps): ReactElement => {
  const handleChange = onChange
    ? (e: ChangeEvent<HTMLInputElement>): void => {
        onChange(e.target.value);
      }
    : undefined;
  const handleBlur = onBlur
    ? (e: ChangeEvent<HTMLInputElement>): void => {
        onBlur(e.target.value);
      }
    : undefined;

  return (
    <Input
      {...rest}
      slotProps={{
        input: {
          ref: innerRef,
          maxLength,
          min,
          max,
          step,
          tabIndex,
        },
      }}
      className={classNames(className)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
